import { render } from "./indexTemplateProposalComponent.vue?vue&type=template&id=878753ea&scoped=true"
import script from "./indexTemplateProposalComponent.vue?vue&type=script&lang=js"
export * from "./indexTemplateProposalComponent.vue?vue&type=script&lang=js"

import "./indexTemplateProposalComponent.vue?vue&type=style&index=0&id=878753ea&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-878753ea"]])

export default __exports__